module.exports = __webpack_public_path__ + "static/media/github.6365b167.svg";